import { GridColumn, useGridStyleHook } from '../hooks/grid-style-hook';
import './control-group-with-preview.scss';

interface IGridStyle {
    childrenWidth: GridColumn;
    previewWidth: GridColumn;
}

interface Props {
    children: React.ReactNode;
    preview?: React.ReactNode;
    hasTopBorder?: boolean;
    gridStyle?: IGridStyle;
}

const controlGroupWithPreviewDefaultPropGridStyle = {
    childrenWidth: { width: 2, type: 'fr' },
    previewWidth: { width: 1, type: 'fr'}
};

const ControlGroupWithPreview: React.FC<Props> = ({ children, preview, hasTopBorder = true, gridStyle = controlGroupWithPreviewDefaultPropGridStyle }) => {
    const style = useGridStyleHook(
        { columns: [gridStyle?.childrenWidth as GridColumn, gridStyle?.previewWidth as GridColumn] }, 
        []
    );


    return (
        <div className={`control-group-with-preview ${hasTopBorder && 'has-top-border'}`} style={style}>
            <div className={`control-group-content`}>
                {children}
            </div>
            <div className={`control-group-preview`}>
                { preview }
            </div>
        </div>
    );
}

export default ControlGroupWithPreview;